export default __webpack_public_path__ + "locales/hy-AM/PaymentsEnterprise.json?hash=3220848b6024c8a51f203a485fec7f0b";